/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raw_Gray_Swan_StepInputs */

const en_raw_gray_swan_step = /** @type {(inputs: Raw_Gray_Swan_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments`)
};

const de_raw_gray_swan_step = /** @type {(inputs: Raw_Gray_Swan_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare`)
};

/**
* | output |
* | --- |
* | "Comments" |
*
* @param {Raw_Gray_Swan_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const raw_gray_swan_step = /** @type {((inputs?: Raw_Gray_Swan_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raw_Gray_Swan_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_raw_gray_swan_step(inputs)
	return de_raw_gray_swan_step(inputs)
});